<template>
  <div class="panel">
    <b-form-group
      label-for="specific-conventional-values"
    >
      <template #label>
        <div class="d-flex align-items-center">
          <h3 class="mb-0 mr-2">
            {{ $t('bearings.headlineConventionalSelection') }}
          </h3>
          <b-button
            id="popover-specific-conventional-values"
            variant="default"
            class="p-0"
            tabindex="-1"
          >
            <font-awesome-icon icon="question-circle" />
          </b-button>
          <b-popover
            target="popover-specific-conventional-values"
            triggers="hover"
            placement="top"
          >
            <template #title>
              {{ $t('bearings.conventionalSelectionTooltipHeadline') }}
            </template>
            <p>{{ $t('bearings.conventionalSelectionTooltip') }}</p>
            <!--            <p v-html="$t('general.tooltipAdditionalInfo')"></p>-->
          </b-popover>
        </div>
      </template>
    </b-form-group>
    <div class="table-responsive">
      <table class="table table-striped">
        <tbody>
          <tr
            :class="{ 'table-danger': !typ100ConventionalIsPossibile,
                      'table-success': typ100ConventionalIsPossibile }"
          >
            <td class="table-col-type">
              {{ $t('general.type') }} 100
            </td>
            <td class="text-right table-col-possibility">
              <b-badge
                v-if="typ100ConventionalIsPossibile"
                variant="success"
              >
                {{ $t('general.possible') }}
              </b-badge>
              <b-badge
                v-if="!typ100ConventionalIsPossibile"
                variant="danger"
              >
                {{ $t('general.notPossible') }}
              </b-badge>
            </td>
            <td class="text-right table-col-recommended">
              <b-badge
                v-if="recommended === 'typ100'"
                variant="info"
              >
                {{ $t('general.recommended') }} *
              </b-badge>
            </td>
            <td class="text-right table-col-print">
              <b-button
                :disabled="!typ100ConventionalIsPossibile"
                variant="success"
                size="sm"
                @click="openModal('typ100')"
              >
                {{ $t('general.print') }}
              </b-button>
            </td>
          </tr>
          <tr
            :class="{ 'table-danger': !typ150ConventionalIsPossibile,
                      'table-success': typ150ConventionalIsPossibile }"
          >
            <td class="table-col-type">
              {{ $t('general.type') }} 150
            </td>
            <td class="text-right table-col-possibility">
              <b-badge
                v-if="typ150ConventionalIsPossibile"
                variant="success"
              >
                {{ $t('general.possible') }}
              </b-badge>
              <b-badge
                v-if="!typ150ConventionalIsPossibile"
                variant="danger"
              >
                {{ $t('general.notPossible') }}
              </b-badge>
            </td>
            <td class="text-right table-col-recommended">
              <b-badge
                v-if="recommended === 'typ150'"
                variant="info"
              >
                {{ $t('general.recommended') }} *
              </b-badge>
            </td>
            <td class="text-right table-col-print">
              <b-button
                :disabled="!typ150ConventionalIsPossibile"
                variant="success"
                size="sm"
                @click="openModal('typ150')"
              >
                {{ $t('general.print') }}
              </b-button>
            </td>
          </tr>
          <tr
            :class="{ 'table-danger': !typ200ConventionalIsPossibile,
                      'table-success': typ200ConventionalIsPossibile }"
          >
            <td class="table-col-type">
              {{ $t('general.type') }} 200
            </td>
            <td class="text-right table-col-possibility">
              <b-badge
                v-if="typ200ConventionalIsPossibile"
                variant="success"
              >
                {{ $t('general.possible') }}
              </b-badge>
              <b-badge
                v-if="!typ200ConventionalIsPossibile"
                variant="danger"
              >
                {{ $t('general.notPossible') }}
              </b-badge>
            </td>
            <td class="text-right table-col-recommended">
              <b-badge
                v-if="recommended === 'typ200'"
                variant="info"
              >
                {{ $t('general.recommended') }} *
              </b-badge>
            </td>
            <td class="text-right table-col-print">
              <b-button
                :disabled="!typ200ConventionalIsPossibile"
                variant="success"
                size="sm"
                @click="openModal('typ200')"
              >
                {{ $t('general.print') }}
              </b-button>
            </td>
          </tr>
        <!-- <tr
          :class="{ 'table-danger': !pyramideIsPossibile, 'table-success': pyramideIsPossibile }"
        >
          <td>{{ $t('bearings.selectionPyramideBearing') }}</td>
          <td class="text-right">
            <b-badge
              v-if="pyramideIsPossibile"
              variant="success"
            >
              {{ $t('general.possible') }}
            </b-badge>
            <b-badge
              v-if="!pyramideIsPossibile"
              variant="danger"
            >
              {{ $t('general.notPossible') }}
            </b-badge>
          </td>
          <td class="text-right">
            <b-badge
              v-if="recommended === 'pyramide'"
              variant="info"
            >
              {{ $t('general.recommended') }} *
            </b-badge>
          </td>
          <td class="text-right">
            <b-button
              :disabled="!pyramideIsPossibile"
              variant="success"
              size="sm"
              @click="openModal('pyramide')"
            >
              {{ $t('general.print') }}
            </b-button>
          </td>
        </tr> -->
        </tbody>
      </table>
    </div>
    <!--    <p class="text-muted">-->
    <!--      * {{ $t('bearings.selectionRecommended') }}-->
    <!--    </p>-->
    <FixedBearingsConventionalModalOutput />
    <div>
      <h3 class="font-weight-bold">
        {{ $t('bearings.bearingConventionalSpecificValues') }}
      </h3>
    </div>
    <div class="table-responsive">
      <table class="table table-striped">
        <thead class="table-dark">
          <tr>
            <th class="th-no-border">&nbsp;</th>
            <th
              colspan="2"
              class="text-center th-no-border"
            >
            </th>
            <th
              colspan="3"
              class="text-center th-no-border"
            >
              {{ $t('bearings.selectionTwistingHeader') }}
            </th>
            <th
              colspan="2"
              class="text-center th-no-border"
            >
              {{ $t('bearings.selectionTransverseTensileForce') }}
            </th>
          </tr>
          <tr>
            <th>&nbsp;</th>
            <th class="text-center">
              R<sub>ꓕ𝖽</sub>
            </th>
            <th class="text-center">
              zul. F<sub>𝖽</sub>
            </th>
            <th class="text-center">
              zul. α<sub>𝖺</sub>
            </th>
            <th class="text-center">
              zul. α<sub>𝖻</sub>
            </th>
            <th class="text-center">
              zul. α<sub>Result.</sub>
            </th>
            <th class="text-center">
              Z<sub>𝖺</sub>
            </th>
            <th class="text-center">
              Z<sub>𝖻</sub>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td
              class="text-center font-weight-bold"
              :class="getBearingTypeClass(bearingThickness, 'conventional', 'typ100')"
            >
              Typ 100
            </td>
            <td
              class="text-center"
              :class="{ 'table-danger' : isExceeded(
                compressiveStress, typ100ConventionalPermissibleCompressiveStress
              ) }"
            >
              <span v-if="!(typ100ConventionalPermissibleCompressiveStress < 0)">
                {{ typ100ConventionalPermissibleCompressiveStress | numeralFormat('0.00') }}
                N/mm<sup>2</sup>
              </span>
            </td>
            <td
              class="text-center"
              :class="{ 'table-danger' : isExceeded(
                power, typ100ConventionalPermissiblePressureForce
              ) }"
            >
              <span v-if="!(typ100ConventionalPermissiblePressureForce < 0)">
                <!-- eslint-disable-next-line max-len -->
                {{ (typ100ConventionalPermissiblePressureForce > 0 ? typ100ConventionalPermissiblePressureForce : 0) | numeralFormat('0.00') }} kN
              </span>
            </td>
            <td
              class="text-center"
              :class="{ 'table-danger' : isExceeded(
                twisting.totalA, typ100PermissibleTwisting.alphaA
              )}"
            >
              {{ typ100PermissibleTwisting.alphaA | numeralFormat('0.0') }} &permil;
            </td>
            <td
              class="text-center"
              :class="{ 'table-danger' : isExceeded(
                twisting.totalB, typ100PermissibleTwisting.alphaB
              )}"
            >
              {{ typ100PermissibleTwisting.alphaB | numeralFormat('0.0') }} &permil;
            </td>
            <td
              class="text-center"
              :class="{ 'table-danger' : isExceeded(
                twistingTotal, typ100PermissibleAlphaResulting
              )}"
            >
              {{ typ100PermissibleAlphaResulting | numeralFormat('0.0') }} &permil;
            </td>
            <td class="text-center">
              {{ transverseTractionEffectA | numeralFormat('0.00') }} kN
            </td>
            <td class="text-center">
              {{ transverseTractionEffectB | numeralFormat('0.00') }} kN
            </td>
          </tr>
          <tr>
            <td
              class="text-center font-weight-bold"
              :class="getBearingTypeClass(
                bearingThickness, 'conventional', 'typ150'
              )"
            >
              Typ 150
            </td>
            <td
              class="text-center"
              :class="{ 'table-danger' : isExceeded(
                compressiveStress, typ150ConventionalPermissibleCompressiveStress
              ) }"
            >
              <span v-if="!(typ150ConventionalPermissibleCompressiveStress < 0)">
                <!-- eslint-disable-next-line max-len -->
                {{ (typ150ConventionalPermissibleCompressiveStress > 0 ? typ150ConventionalPermissibleCompressiveStress : 0) | numeralFormat('0.00') }}
                N/mm<sup>2</sup>
              </span>
            </td>
            <td
              class="text-center"
              :class="{ 'table-danger' : isExceeded(
                power, typ150ConventionalPermissiblePressureForce
              ) }"
            >
              <span v-if="!(typ150ConventionalPermissiblePressureForce < 0)">
                <!-- eslint-disable-next-line max-len -->
                {{ (typ150ConventionalPermissiblePressureForce > 0 ? typ150ConventionalPermissiblePressureForce : 0) | numeralFormat('0.00') }} kN
              </span>
            </td>
            <td
              class="text-center"
              :class="{ 'table-danger' : isExceeded(
                twisting.totalA, typ150PermissibleTwisting.alphaA
              )}"
            >
              {{ typ150PermissibleTwisting.alphaA | numeralFormat('0.0') }} &permil;
            </td>
            <td
              class="text-center"
              :class="{ 'table-danger' : isExceeded(
                twisting.totalB, typ150PermissibleTwisting.alphaB
              )}"
            >
              {{ typ150PermissibleTwisting.alphaB | numeralFormat('0.0') }} &permil;
            </td>
            <td
              class="text-center"
              :class="{ 'table-danger' : isExceeded(
                twistingTotal, typ150PermissibleAlphaResulting
              )}"
            >
              {{ typ150PermissibleAlphaResulting | numeralFormat('0.0') }} &permil;
            </td>
            <td class="text-center">
              {{ transverseTractionEffectA | numeralFormat('0.00') }} kN
            </td>
            <td class="text-center">
              {{ transverseTractionEffectB | numeralFormat('0.00') }} kN
            </td>
          </tr>
          <tr>
            <td class="text-center font-weight-bold"
                :class="getBearingTypeClass(bearingThickness, 'conventional', 'typ200')"
            >
              Typ 200
            </td>
            <td
              class="text-center"
              :class="{ 'table-danger' : isExceeded(
                compressiveStress, typ200ConventionalPermissibleCompressiveStress
              ) }"
            >
              <span v-if="!(typ200ConventionalPermissibleCompressiveStress < 0)">
                <!-- eslint-disable-next-line max-len -->
                {{ (typ200ConventionalPermissibleCompressiveStress > 0 ? typ200ConventionalPermissibleCompressiveStress : 0) | numeralFormat('0.00') }}
                N/mm<sup>2</sup>
              </span>
            </td>
            <td
              class="text-center"
              :class="{ 'table-danger' : isExceeded(
                power, typ200ConventionalPermissiblePressureForce
              ) }"
            >
              <span v-if="!(typ200ConventionalPermissiblePressureForce < 0)">
                <!-- eslint-disable-next-line max-len -->
                {{ (typ200ConventionalPermissiblePressureForce > 0 ? typ200ConventionalPermissiblePressureForce : 0) | numeralFormat('0.00') }} kN
              </span>
            </td>
            <td
              class="text-center"
              :class="{ 'table-danger' : isExceeded(
                twisting.totalA, typ200PermissibleTwisting.alphaA
              )}"
            >
              {{ typ200PermissibleTwisting.alphaA | numeralFormat('0.0') }} &permil;
            </td>
            <td
              class="text-center"
              :class="{ 'table-danger' : isExceeded(
                twisting.totalB, typ200PermissibleTwisting.alphaB
              )}"
            >
              {{ typ200PermissibleTwisting.alphaB | numeralFormat('0.0') }} &permil;
            </td>
            <td
              class="text-center"
              :class="{ 'table-danger' : isExceeded(
                twistingTotal, typ200PermissibleAlphaResulting
              )}"
            >
              {{ typ200PermissibleAlphaResulting | numeralFormat('0.0') }} &permil;
            </td>
            <td class="text-center">
              {{ transverseTractionEffectA | numeralFormat('0.00') }} kN
            </td>
            <td class="text-center">
              {{ transverseTractionEffectB | numeralFormat('0.00') }} kN
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line no-console
import { mapState, mapGetters } from 'vuex';
import FixedBearingsConventionalModalOutput from '@/components/fixedBearings/FixedBearingsConventionalModalOutput.vue';
import CalcToolsTransverseTractionHelper from '../../helpers/CalcToolsTransverseTractionHelper';

export default {
  name: 'FixedBearingsFormEffects',
  components: {
    FixedBearingsConventionalModalOutput,
  },
  // props: {
  //   propBearingWidth: {
  //     type: Number,
  //     default: 100,
  //   },
  //   propBearingLength: {
  //     type: Number,
  //     default: 150,
  //   },
  //   propBearingThickness: {
  //     type: Number,
  //     default: 20,
  //   },
  //   propPower: {
  //     type: Number,
  //     default: 100,
  //   },
  // },
  data() {
    return {
      typ100IsRecommended: true,
      typ150IsRecommended: false,
      typ200IsRecommended: false,
      pyramideIsRecommended: false,
      modalShow: false,
      bearingThicknessOptions: Object.values(this.$dataOptionsHelper.getBearingThicknessOptions()),
      // steelStretchMax: 435,
      // bearingWidth: this.propBearingWidth,
      // bearingLength: this.propBearingLength,
      // bearingThickness: this.propBearingThickness,
      // power: this.propPower,
    };
  },
  computed: {
    ...mapState({
      bearingWidth: state => state.fixedBearingWidth,
      bearingLength: state => state.fixedBearingLength,
      bearingThickness: state => state.fixedBearingThickness,
      power: state => state.fixedBearingPressureForce,
      fixedBearingTwistingA: state => state.fixedBearingTwistingA,
      fixedBearingTwistingB: state => state.fixedBearingTwistingB,
      countHoles: state => state.fixedBearingHolesCount,
      holesDiameter: state => state.fixedBearingHolesDiameter,
    }),
    ...mapGetters([
      'warningMessages',
      'typ100ConventionalPermissibleCompressiveStress',
      'typ100PermissibleTwisting',
      'typ100PermissibleAlphaResulting',
      'typ100ConventionalIsPossibile',
      'typ100ConventionalPermissiblePressureForce',
      'typ150ConventionalPermissibleCompressiveStress',
      'typ150PermissibleTwisting',
      'typ150PermissibleAlphaResulting',
      'typ150ConventionalPermissiblePressureForce',
      'typ150ConventionalIsPossibile',
      'typ200ConventionalPermissibleCompressiveStress',
      'typ200PermissibleTwisting',
      'typ200PermissibleAlphaResulting',
      'typ200ConventionalPermissiblePressureForce',
      'typ200ConventionalIsPossibile',
      'pyramideIsPossibile',
      'twistingTotal',
      'twisting',
    ]),
    compressiveStress() {
      return CalcToolsTransverseTractionHelper.getCompressiveStress(
        this.bearingWidth,
        this.bearingLength,
        this.$outputHelper.convertToInteger(this.power),
        this.countHoles,
        this.holesDiameter,
      );
    },
    // effectUprightFactor() {
    //   return CalcToolsTransverseTractionHelper.getEffectUprightFactor(
    //     this.bearingWidth,
    //     this.bearingLength,
    //     this.$outputHelper.convertToInteger(this.power) * 1000,
    //   );
    // },
    transverseTractionEffectA() {
      return CalcToolsTransverseTractionHelper.getConventionalTransverseTractionA(
        this.bearingWidth,
        this.bearingLength,
        this.bearingThickness,
        this.power,
        this.compressiveStress,
      );
    },
    transverseTractionEffectB() {
      return CalcToolsTransverseTractionHelper.getConventionalTransverseTractionB(
        this.bearingWidth,
        this.bearingLength,
        this.bearingThickness,
        this.power,
        this.compressiveStress,
      );
    },
    recommended() {
      let bearingType = '';
      /* if (this.pyramideIsPossibile) {
        bearingType = 'pyramide';
      } else */
      if (
      /* !this.pyramideIsPossibile
          && */
        this.typ100ConventionalIsPossibile
      ) {
        bearingType = 'typ100';
      } else if (
      /* !this.pyramideIsPossibile
          &&  */
        !this.typ100ConventionalIsPossibile
          && this.typ150ConventionalIsPossibile
      ) {
        bearingType = 'typ150';
      } else if (
      /* !this.pyramideIsPossibile
          && */
        !this.typ100ConventionalIsPossibile
          && !this.typ150ConventionalIsPossibile
          && this.typ200ConventionalIsPossibile
      ) {
        bearingType = 'typ200';
      }
      return bearingType;
    },
  },
  methods: {
    openModal(type) {
      this.$store.commit('fixedBearingSelectedBearingType', type);
      this.$bvModal.show('conventionalModalOutput');
    },
    isExceeded(actual, permissible) {
      return actual > permissible;
    },
    getBearingTypeClass(bearingThickness, formBearingType, typ) {
      // unter Mindestdicke → neutral
      if (bearingThickness < 25) {
        return null;
      }

      // gültige Kombination → grün
      if (typ === 'typ100' && formBearingType === 'conventional') {
        return null;
      }

      // sonst ungültig → rot
      return 'table-danger';
    },
  },
};
</script>

<style scoped lang="scss">
  .table-col-type {
    width: 25%;
  }
  .table-col-possibility {
    width: 25%;
  }
  .table-col-recommended {
    width: 25%;
  }
  .table-col-print {
    width: 25%;
  }
  .th-no-border {
    border-bottom: none;
  }
</style>
